import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { PieChart } from '@mui/x-charts/PieChart';
import { Tooltip as MuiTooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const CondoPieChart = ({ data }) => {
  const [unitDistribution, setUnitDistribution] = useState({ occupied: 0, vacant: 0 });
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/properties');
  };

  useEffect(() => {
    if (!data) return;

    const occupied = data.filter(item => item.isAvailable === false).length;
    const vacant = data.filter(item => item.isAvailable === true).length;

    setUnitDistribution({ occupied, vacant });
  }, [data]);

  const pieData = [
    { id: 0, value: unitDistribution.occupied, color: "#C86B2C" },
    { id: 1, value: unitDistribution.vacant, color: "#D4967D" }
  ];

  const totalUnits = unitDistribution.occupied + unitDistribution.vacant;

  return (
    <div className="occupancy-card">
      <div className="tooltip-header" style={{ display: "flex", alignItems: "center" }}>
        <MuiTooltip title="This is the unit distribution." arrow>
          <IconButton>
            <HelpOutlineIcon sx={{ fontSize: '18px', color: 'grey' }} />
          </IconButton>
        </MuiTooltip>
        <button className="redirect-btn" onClick={handleNavigate}>
          <i className="fa-solid fa-arrow-up-right-from-square"></i>
        </button>
      </div>
      <div className="occupancy-pie">
        <div style={{ position: "relative", width: 160, height: 160 }}>
          <PieChart
            height={160}
            width={160}
            series={[{ data: pieData, innerRadius: 55, outerRadius: 80 }]}
            colors={pieData.map(item => item.color)}
            slotProps={{ legend: { hidden: true } }}
          />
          <div className="occupancy-labels">
            Occupied {unitDistribution.occupied} &nbsp;
            Vacant {unitDistribution.vacant}
          </div>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              pointerEvents: "none"
            }}
          >
            <div style={{ fontSize: "24px", fontWeight: "bold" }}>{totalUnits}</div>
            <div style={{ fontSize: "15px", color: "#666" }}>Total Units</div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default CondoPieChart;
